export class Task{
    public _id: number
    public method: string
    public params: Array<any>
    public module_id: number
    // Statusdaten
    public intervall: number
    public status: string = 'normal'

    constructor(id:number, method:string, params:Array<any>, module_id){
      this._id = id;
      this.method = method;
      this.params = params;
      this.module_id = module_id;
    }
}



// WEBPACK FOOTER //
// ./src/objects/task.class.ts